import {AfterViewInit, Component, HostBinding, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {TransportInterventionsPageRequest} from '../transport-interventions-page/transport-interventions-page-request';
import {Subscription} from 'rxjs';
import {TransportInterventionsNavigationActivatedComponent} from '../transport-interventions-navigation/transport-interventions-navigation-activated-component';
import {DashboardService} from '../../services/dashboard.service';
import {WebsocketService} from '../../services/websocket/websocket.service';
import {
  FollowInterventionWSE,
  StartTransportInterventionsRealtimeWSE,
  StopTransportInterventionsRealtimeWSE
} from '../../services/websocket/websocket-event';
import DataSource from 'devextreme/data/data_source';
import {TransportInterventionService} from '../../stores/transport-intervention.service';
import {durationToStr, TransportIntervention} from 'shared';
import ArrayStore from 'devextreme/data/array_store';

@Component({
  selector: 'app-transport-interventions-dashboard',
  templateUrl: './transport-interventions-dashboard.component.html',
  styleUrls: ['./transport-interventions-dashboard.component.scss']
})
export class TransportInterventionsDashboardComponent extends TransportInterventionsNavigationActivatedComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  ds: DataSource;

  @Input()
  request: TransportInterventionsPageRequest;

  @Input()
  width: number;

  @Input()
  height: number;

  @Input()
  @HostBinding('hidden')
  hidden: boolean;
  private submitSub: Subscription;
  private hasPendingRequest: boolean;
  dashboardTimeToolbar;
  dashboardData: any;

  constructor(
    private dashboardService: DashboardService,
    private ws: WebsocketService,
    private transportInterventionService: TransportInterventionService,
  ) {
    super();
  }

  ngOnInit(): void {

    const metricsList = [
      {
        text: 'Distances',
        valueField: 'length_in_km',
        unit: 'Km',
        aggregationMethod: 'avg',
        color: '#e91e63',
        customizeText: (arg) => {
          return arg.value.toFixed(2) + ' km';
        }
      },
      {
        text: 'Vitesse',
        valueField: 'speed_avg',
        unit: 'Km/h',
        aggregationMethod: 'avg',
        color: '#1ee980',
        customizeText: (arg) => {
          return arg.value.toFixed(2) + ' km/h';
        }
      },
      {
        text: 'Vitesse Maximale',
        valueField: 'speed_max',
        unit: 'Km/h',
        aggregationMethod: 'avg',
        color: '#e91ed5',
        customizeText: (arg) => {
          return arg.value.toFixed(2) + ' km/h';
        }
      },
      {
        text: 'Consomation Carburant',
        valueField: 'fuel_total_consumption',
        unit: 'L',
        aggregationMethod: 'avg',
        color: '#1e68e9',
        customizeText: (arg) => {
          return arg.value.toFixed(2) + ' L';
        }
      },
      {
        text: 'Consomation Carburant en L/h',
        valueField: 'fuel_hourly_consumption_rate_avg',
        unit: 'L/h',
        aggregationMethod: 'avg',
        color: '#e9581e',
        customizeText: (arg) => {
          return arg.value.toFixed(2) + ' L/h';
        }
      },
      {
        text: 'Heures Moteurs',
        valueField: 'engine_working_hours',
        unit: 'h',
        aggregationMethod: 'avg',
        color: '#5be91e',
        customizeText: (arg) => {
          return durationToStr(arg.value, true);
        }
      },
      {
        text: 'Temperature Carburant',
        valueField: 'fuel_temperature_avg',
        unit: '°C',
        aggregationMethod: 'avg',
        color: '#e9ce1e',
        customizeText: (arg) => {
          return arg.value.toFixed(2) + ' °C';
        }
      },
    ];

    this.dashboardTimeToolbar = [
      {
        name: 'valueField',
        options: {
          items: metricsList,
          stylingMode: 'outlined',
          keyExpr: 'text',
          displayExpr: 'text',
          valueExpr: 'text',
          selectedItemKey: 'Distances',
          useSelectMode: true,
          dropDownOptions: {width: 200}
        },
        locateInMenu: 'never',
        widget: 'dxDropDownButton',
        location: 'after',
      },
      {
        template: () => {
          return '<span class="ml-2">Par: </span>';
        },
        locateInMenu: 'never',
        location: 'after',
      },
      {
        name: 'aggregationInterval',
        options: {
          items: [
            {text: 'Heure', aggregationInterval: 'hour'},
            {text: 'Jour', aggregationInterval: 'day'},
            {text: 'Semaine', aggregationInterval: 'week'},
            {text: 'Mois', aggregationInterval: 'month'},
            {text: 'Année', aggregationInterval: 'year'},
          ],
          stylingMode: 'outlined',
          keyExpr: 'text',
          selectedItemKeys: ['Heure'],
        },
        locateInMenu: 'never',
        widget: 'dxButtonGroup',
        location: 'after',
      },
    ];
  }

  private loadRequest() {
    this.request.isLoading = true;
    this.transportInterventionService.dashboard(this.request.from, this.request.to).subscribe((data) => {
      this.dashboardData = data;
      this.request.isLoading = false;
    });

    this.hasPendingRequest = false;
  }

  onActivated() {
    if (this.hasPendingRequest) {
      setTimeout(() => {
        this.loadRequest();
      }, 10);
    }
    this.ws.send(new StartTransportInterventionsRealtimeWSE());
  }

  onDeactivated() {
    this.ws.send(new StopTransportInterventionsRealtimeWSE());
  }

  ngOnDestroy(): void {
    this.submitSub.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.submitSub = this.request.submit$.subscribe(() => {
      if (this.isActivated) {
        setTimeout(() => {
          this.loadRequest();
        }, 10);
      } else {
        this.hasPendingRequest = true;
      }
    });
  }

}
